import type { FreelancerLandingLocales } from '../types';

const freelancerLandingLocales: FreelancerLandingLocales = {
  childcareFreelancers: 'Child care freelancers',
  title: 'Welcome',
};

export default freelancerLandingLocales;
